import React, { useState, useEffect } from 'react'
import Container from './container'

export default function AreasVertical({
  slides = [],
  bgColor = 'bg-gradient-to-r from-[#4B3BDB] to-[#A002CB]',
}) {
  const [currentSlide, setCurrentSlide] = useState(0)

  const handleTabClick = index => {
    setCurrentSlide(index)
  }

  return (
    <div className="w-full bg-[#040116] py-12 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="w-full h-full object-cover"
        />
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
        />
      </div>

      <Container className="relative z-10 mt-12 ">
        <div className="flex justify-center mb-12">
          <div className="inline-flex rounded-full text-lg md:text-3xl gap-2">
            {slides.map((slide, index) => (
              <button
                key={index}
                onClick={() => handleTabClick(index)}
                className={`px-3 md:px-8 py-2 rounded-full transition-all duration-300 cursor-pointer ${
                  currentSlide === index
                    ? `${bgColor} text-white font-inter-bold`
                    : 'text-white font-inter-light'
                }`}
                type="button"
              >
                {slide.title}
              </button>
            ))}
          </div>
        </div>

        {/* Conteúdo do slide */}
        <Container className="text-center transition-opacity duration-500">
          <p className="text-white text-2xl md:text-3xl lg:text-5xl lg:leading-16 font-inter-light">
            {slides[currentSlide].text}
          </p>
        </Container>

        {/* Indicadores do carrossel */}
        <div className="flex justify-center mt-24 gap-3 items-center">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              type="button"
              className={`${
                currentSlide === index ? 'w-[8px]' : 'w-[24px]'
              } h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
                currentSlide === index
                  ? 'bg-white'
                  : 'bg-transparent border border-white'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </Container>
      <div className="hidden lg:block absolute bottom-10 left-48 w-[326px]">
        <img src="/assets/arrow_gradient.svg" alt="Next" className="w-full" />
      </div>
    </div>
  )
}
